import React, { lazy } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import OurPlacesV2Boundary from './ErrorBoundary';

const Workspace = lazy(() => import('../Workspace/Workspace'));
const LegacyMap = lazy(() => import('../../Map/map'));

/**
 * `/ourplaces` is the Megan workspace now (it replaced the v1 map on launch).
 * Links already out in the world still have to land somewhere sensible:
 *
 *   - `provider` / `zip` — partner campaign links (the Pigtails ad) use
 *     filters only the classic map implements. They keep rendering it until
 *     the directory grows both; see docs/ourplaces_v2/campaign-links.md.
 *   - any other search vocabulary (`tags`, `lat`, `loc`, `radius`, …) — a
 *     shared search. Same vocabulary as the directory, so it moves there.
 *   - everything else (including `?workspace={id}` from the profile page) —
 *     the conversation.
 */
const LEGACY_ONLY = ['provider', 'zip'];
const SEARCH_VOCABULARY = ['tags', 'lat', 'lng', 'loc', 'radius', 'q', 'attrs', 'sort', 'view'];

export const OUR_PLACES_PATH = '/ourplaces';
export const OUR_PLACES_SEARCH_PATH = '/ourplaces/search';

const OurPlacesEntry = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  if (LEGACY_ONLY.some((key) => params.has(key))) return <LegacyMap />;
  if (SEARCH_VOCABULARY.some((key) => params.has(key))) {
    return <Navigate to={`${OUR_PLACES_SEARCH_PATH}${search}`} replace />;
  }
  return (
    <OurPlacesV2Boundary>
      <Workspace />
    </OurPlacesV2Boundary>
  );
};

/** Old `/ourplacesv2…` and `/map` URLs: same destination, query intact. */
export const RedirectTo = ({ path }) => {
  const { search, hash } = useLocation();
  return <Navigate to={`${path}${search}${hash}`} replace />;
};

export default OurPlacesEntry;
